export const yan = 'yan';

const yan2 = 'yan2';

export default yan2;

class A {
  aaa() {}
}

export class B extends A {
  bbb() {}
}
